import React from 'react';
import { Layout, LayoutProps } from 'react-admin';
import { CSAdminAppBar } from './app-bar';

export const CSAdminLayout = ({ children, ...props }: LayoutProps) => (
  <Layout {...props} appBar={CSAdminAppBar} sx={{ marginTop: 1 }}>
    {children}
  </Layout>
);
